import React, { useEffect } from 'react';

import './SelectCellsRectangle.less';

interface Props {
  isSelectingCellsActive: boolean;
  onSelectingCellsStarted: () => void;
  onSelectingCellsFinished: () => void;
}

export const SelectCellsRectangle = React.forwardRef<HTMLDivElement, Props>(
  (
    {
      isSelectingCellsActive,
      onSelectingCellsStarted,
      onSelectingCellsFinished,
    },
    ref
  ) => {
    useEffect(() => {
      if (isSelectingCellsActive) {
        window.addEventListener('mouseup', onSelectingCellsFinished);
      }
      return () => {
        window.removeEventListener('mouseup', onSelectingCellsFinished);
      };
    }, [isSelectingCellsActive, onSelectingCellsFinished]);

    return (
      <div
        ref={ref}
        onMouseDown={onSelectingCellsStarted}
        className="selectCellsRectangle"
      />
    );
  }
);
